/** CELEX id for the Machinery Directive compliance studio. */
export const MACHINERY_DIRECTIVE_STUDIO_ID = '32006L0042'

/** Display title for the Machinery Directive compliance studio (English). */
export const MACHINERY_DIRECTIVE_STUDIO_TITLE =
  'Machinery Directive (2006/42/EC)'

/** Display title for the Machinery Directive compliance studio (German). */
export const MACHINERY_DIRECTIVE_STUDIO_TITLE_DE =
  'Maschinenrichtlinie (2006/42/EG)'

/** CELEX id for the Machinery Regulation compliance studio. */
export const MACHINERY_REGULATION_STUDIO_ID = '32023R1230'

/** Display title for the Machinery Regulation compliance studio (English). */
export const MACHINERY_REGULATION_STUDIO_TITLE =
  'Machinery Regulation (EU) 2023/1230'

/** Display title for the Machinery Regulation compliance studio (German). */
export const MACHINERY_REGULATION_STUDIO_TITLE_DE =
  'Maschinenverordnung (EU) 2023/1230'

export type ComplianceStudioCatalogEntry = {
  id: string
  title: string
  /** When false, the studio is visible but not yet creatable. Defaults to true. */
  available?: boolean
}

/** Alias used by client UI code. */
export type ComplianceStudio = ComplianceStudioCatalogEntry

/** Canonical compliance studio catalog (code-backed; no DB table). */
export const COMPLIANCE_STUDIO_CATALOG: ComplianceStudioCatalogEntry[] = [
  {
    id: MACHINERY_DIRECTIVE_STUDIO_ID,
    title: MACHINERY_DIRECTIVE_STUDIO_TITLE,
  },
  {
    id: MACHINERY_REGULATION_STUDIO_ID,
    title: MACHINERY_REGULATION_STUDIO_TITLE,
    available: false,
  },
]

export function isComplianceStudioAvailable(
  entry: ComplianceStudioCatalogEntry
): boolean {
  return entry.available !== false
}

/** Available studios only — keeps existing COMPLIANCE_STUDIOS consumers unchanged. */
export const COMPLIANCE_STUDIOS = COMPLIANCE_STUDIO_CATALOG.filter(
  isComplianceStudioAvailable
)

const COMPLIANCE_STUDIO_ID_SET = new Set(
  COMPLIANCE_STUDIO_CATALOG.map((studio) => studio.id)
)

const availableComplianceStudioIdSet = new Set(
  COMPLIANCE_STUDIOS.map((studio) => studio.id)
)

const complianceStudioTitleById = new Map(
  COMPLIANCE_STUDIO_CATALOG.map((studio) => [studio.id, studio.title])
)

/** Returns known studio ids from the given list, preserving input order. */
export function filterKnownComplianceStudioIds(
  ids: string[],
  opts?: { includeUnavailable?: boolean }
): string[] {
  const knownIdSet =
    opts?.includeUnavailable === true
      ? COMPLIANCE_STUDIO_ID_SET
      : availableComplianceStudioIdSet
  const seen = new Set<string>()
  const result: string[] = []
  for (const id of ids) {
    if (!knownIdSet.has(id) || seen.has(id)) {
      continue
    }
    seen.add(id)
    result.push(id)
  }
  return result
}

export function getComplianceStudioTitle(studioId: string): string | undefined {
  return complianceStudioTitleById.get(studioId)
}
